<template>
  <div
    class="aup-public-profile-lens row"
    v-masonry
    transition-duration="0.3s"
    item-selector=".aup-public-profile-lens__lens-item"
  >
    <BaseGearCard
      v-for="lens in gearLenses"
      :key="lens.ppd_gear_lockerid"
      :name="lensDictionary[lens.ppd_model].name"
      :model="lens.ppd_model"
      :image="lensDictionary[lens.ppd_model].imageUrl"
	  :gearLink="lensDictionary[lens.ppd_model].productUrl"
      :lens="true"
      v-masonry-tile
      class="aup-public-profile-lens__lens-item"
    />
  </div>
</template>
<script>
import { API_GET_PUBLIC_PROFILE, API_GET_EQUIPMENT} from "@/api-service.js";
import { PROFILE_CONSTANTS } from "@/PROFILE_CONSTANTS";

export default {
  name: "Lens",
  props: {
    gearLenses: {
      type: Array,
      default: () => []
    },
    utmCodesUsage: {
      type: String,
      default:''
    },
  },
  data() {
    return {
      initializingMasonry: false,
      equipment: {}
    };
  },
  computed: {
    lensDictionary() {
      let dictionary = {};
      if(this.equipment.SONY_LENSES) {
        this.equipment.SONY_LENSES.forEach(lens => {
          dictionary[lens.model] = lens;
        });
      }

      //Add utm codes to lens url
      if(this.utmCodesUsage && this.equipment.UTM_CODES) {
        const utmToUse = this.equipment.UTM_CODES.find(el => el.useage === this.utmCodesUsage);
        if(utmToUse) {
          for(let lens in dictionary) {
            dictionary[lens].productUrl = dictionary[lens].productUrl + utmToUse.utmCode;
          }
        }
      }

      return dictionary;
    }
  },
  created: async function() {
    const equipmentResponse = await API_GET_EQUIPMENT();
    if (equipmentResponse.status === 200) {
      this.equipment = equipmentResponse.data;
    }
  }
};
</script>
